import { render } from "./BimPlusUser.vue?vue&type=template&id=bdc8bf74"
import script from "./BimPlusUser.vue?vue&type=script&lang=js"
export * from "./BimPlusUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__